<template>
  <div class="orders-page container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="艺术家" name="designer" v-if="uid === 1"></el-tab-pane>
          <el-tab-pane label="商品品牌" name="brand" v-if="uid === 1"></el-tab-pane>
          <el-tab-pane label="商品属性" name="attribute" v-if="uid === 1"></el-tab-pane>
          <el-tab-pane label="商品标签" name="tags" v-if="uid === 1"></el-tab-pane>
          <el-tab-pane label="商品分类" name="category" v-if="uid === 1"></el-tab-pane>
          <el-tab-pane label="商品列表" name="list"></el-tab-pane>
          <el-tab-pane label="SY商品" name="shopify" v-if="uid === 1"></el-tab-pane>
          <el-tab-pane label="商品表单" name="forms" v-if="uid === 1"></el-tab-pane>
          <el-tab-pane label="商品特效" name="prompts" v-if="uid === 1"></el-tab-pane>
          <el-tab-pane label="商品评论" name="review" v-if="uid === 1"></el-tab-pane>
      </el-tabs>        
      <component :is="activeName"></component>        
  </div>
</template>
<script>
const designer = resolve => require(['@/pages/goods/designer/_list'], resolve);  
const attribute = resolve => require(['@/pages/goods/attribute/_list'], resolve);  
const brand = resolve => require(['@/pages/goods/brand/_list'], resolve);  
const tags = resolve => require(['@/pages/goods/tags/_list'], resolve);  
const category = resolve => require(['@/pages/goods/category/_list'], resolve);  
const list = resolve => require(['@/pages/goods/_list'], resolve);  
const shopify = resolve => require(['@/pages/goods/shopify/_list'], resolve);  
const forms = resolve => require(['@/pages/goods/forms/_list'], resolve);  
const prompts = resolve => require(['@/pages/goods/prompts/_list'], resolve);  
const review = resolve => require(['@/pages/goods/review/_list'], resolve);  
export default {
  components:{
    designer,brand,attribute,tags,category,list,shopify,review,forms,prompts
  },
  data(){
    return {
        activeName:'list',
        uid:0,
    }
  },
  methods:{
    handleClick(e){

    },
  },
  mounted() {
    this.$store.commit('set_current_menu', {name:'goods'});
    var admin_password = this.getCookie("admin_password");
    if (admin_password === 'b1315E8') {
      this.uid = parseInt(localStorage.getItem("uid"));
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/goods/Index.vue